import React, { Dispatch, SetStateAction } from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

interface disconnectModalProps {
  showModal: boolean;
  setShowModal: Dispatch<SetStateAction<boolean>>;
  disconnectCall: (forAll?: boolean) => void;
  userType: string;
}

export default function CallDisconnectModal({
  showModal,
  setShowModal,
  disconnectCall,
  userType,
}: disconnectModalProps) {
  const handleClose = () => {
    setShowModal(false);
  };

  return (
    <Dialog
      open={showModal}
      onClose={handleClose}
      disableEscapeKeyDown
      disableBackdropClick
      fullWidth={true}
      maxWidth="xs"
    >
      <DialogTitle>Disconnect Confirmation</DialogTitle>
      <DialogContent>
        <DialogContentText> Are you sure want to disconnect from this call? </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button
          variant="contained"
          onClick={() => {
            handleClose();
            disconnectCall();
          }}
          color="secondary"
        >
          Disconnect
        </Button>
        <Button variant="contained" onClick={handleClose}>
          Cancel
        </Button>
      </DialogActions>
    </Dialog>
  );
}
